import {connect} from 'react-redux'
import ResetPasswordForm from './ResetPasswordForm'
import ResetPasswordFormInvalid from './ResetPasswordFormInvalid'
import styles from './style.css'
import {loadResetPassword, resetPassword, loadPrepareEncryption, forgotPassword} from 'actions'
class ResetPassword extends React.Component {
  componentDidMount () {
    let resetPasswordToken = this.props.params.token
    this.props.dispatch(loadResetPassword(resetPasswordToken))
    this.props.dispatch(loadPrepareEncryption())
  }
  render () {
    let {dispatch, data} = this.props
    let resetState = data.moka.resetPasswordState
    return (
      <div className='container'>
        <div className='row'>
          <div className={styles.root} id='reset-password-page'>
            {
              resetState.tokenError
              ? <div>
                <h3 className={styles['title-panel']}>{'Link Expired :('}</h3>
                <ResetPasswordFormInvalid
                  dispatch={dispatch}
                  history={this.props.history}
                  onSubmit={this.sendForgotPassword}
                  btnText={'Submit'}
                  />
              </div>
              : <div>
                <h3 className={styles['title-panel']}>Reset your password</h3>
                <ResetPasswordForm
                  dispatch={dispatch}
                  fullName={resetState.fullName}
                  history={this.props.history}
                  onSubmit={this.handleSubmit}
                  btnText={'Reset Password'}
                  />
              </div>
            }
          </div>
        </div>
      </div>
    )
  }

  /**
   * Handle submission of login form
   * @param values the JSON containing {email,password}
   */

  sendForgotPassword = (values) => {
    let {email} = values
    this.props.dispatch(forgotPassword({email}))
  }

  handleSubmit = (values) => {
    let resetPasswordToken = this.props.params.token
    this.props.dispatch(resetPassword(values, resetPasswordToken))
  }
}

// Which props do we want to inject, given the global state?
function select (state) {
  return {
    data: state
  }
}

// Wrap the component to inject dispatch and state into it
export default connect(select)(ResetPassword)



// WEBPACK FOOTER //
// ./app/pages/ResetPassword/ResetPassword.js